'use client';

import { Typography } from '@musinsa/mds';
import { HtmlContentRenderer } from '../../../../agreements/components/HtmlContentRenderer';
import { useStaticHtmlContent } from '../../../../agreements/hooks/useStaticHtmlContent';
import {
  getSeedingTermHtmlPath,
  SEEDING_TERM_HTML_CLASS,
  SEEDING_TERMS,
  type SeedingTermId,
} from './seedingTerms';

interface SeedingTermDetailProps {
  /** 표시할 약관 id (없거나 미존재면 안내 문구). */
  termId: SeedingTermId | null;
}

/**
 * 시딩 약관 본문 — desktop 웹 "자세히" 새 탭 라우트(`/campaign/seeding/terms`)용 풀페이지 렌더.
 * `SeedingTermsSheet`(모바일/웹뷰 바텀시트)와 **동일 렌더 경로**(getSeedingTermHtmlPath +
 * useStaticHtmlContent + HtmlContentRenderer/DOMPurify)라 스타일(c1/c4 등)이 시트와 일치한다.
 */
export const SeedingTermDetail = ({ termId }: SeedingTermDetailProps) => {
  const term = SEEDING_TERMS.find((item) => item.id === termId) ?? null;

  const { htmlContent, isLoading, error } = useStaticHtmlContent(
    term ? getSeedingTermHtmlPath(term.htmlFile) : '',
    { enabled: term !== null },
  );

  if (!term) {
    return (
      <Typography variant="body13pxReg" colorScheme="gray-600">
        약관 정보를 찾을 수 없습니다.
      </Typography>
    );
  }

  return (
    <div className="safe-area-bottom">
      {isLoading && (
        <Typography variant="body13pxReg" colorScheme="gray-600">
          약관을 불러오는 중입니다.
        </Typography>
      )}
      {error && !isLoading && (
        <Typography variant="body13pxReg" colorScheme="gray-600">
          약관을 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.
        </Typography>
      )}
      {!isLoading && !error && htmlContent && (
        <HtmlContentRenderer html={htmlContent} className={SEEDING_TERM_HTML_CLASS} />
      )}
    </div>
  );
};
